import {
    CLAIMS_POPUP_FETCH_COMMAND,
    CLAIMS_POPUP_MODAL_CONFIRM,
    CLAIMS_POPUP_MODAL_OPEN
} from '../../actions/claims/actionClaimsPopUpModal';
import {claimsWebsocketCommands} from '../../constants/claimsWebsocketCommands';
import get from 'get-value';

export const claimsPopUpModal = (state = {
    isOpen: false,
    isConfirm: false,
    isLoading: false,
    popUp: {},
}, action) => {
    switch (action.type) {
        case CLAIMS_POPUP_FETCH_COMMAND: {
            return Object.assign({}, state, {isLoading: true});
        }
        case claimsWebsocketCommands.CLAIMS_POPUP_SEND: {
            const {correlationId} = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                isLoading: false,
                popUp: get(action, 'payload.popup', {default: {}}),
                correlationId
            });
        }
        case claimsWebsocketCommands.CLAIMS_POPUP_SEND_ERROR: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {isLoading: false, popUp: {}, correlationId});
        }
        case CLAIMS_POPUP_MODAL_OPEN: {
            return Object.assign({}, state, {isOpen: true});
        }
        case CLAIMS_POPUP_MODAL_CONFIRM: {
            return Object.assign({}, state, {isOpen: false, isConfirm: true});
        }
        default:
            return state;
    }
};

